import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 581,
	height: 581,
	viewBox: "0 0 581 581",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008V580.034",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L335.377 576.447",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L379.63 565.836",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L421.674 548.418",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L460.48 524.639",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L495.086 495.082",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L524.643 460.477",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L548.421 421.67",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L565.84 379.626",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L576.451 335.373",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008H580.038",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.01L576.451 244.645",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.009L565.84 200.391",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.01L548.421 158.348",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.008L524.643 119.539",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.011L495.086 84.9375",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.009L460.48 55.3945",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.01L421.674 31.6172",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.007L379.63 14.1953",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.01L335.377 3.57031",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.012 290.009V0",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.01L244.645 3.57031",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.009 290.007L200.391 14.1953",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.01L158.348 31.6172",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.008 290.009L119.539 55.3945",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.011 290.011L84.9375 84.9375",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.009 290.008L55.3945 119.539",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.01L31.6172 158.348",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.011 290.009L14.1992 200.391",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.01L3.57031 244.645",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.009 290.008H0",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.008L3.57031 335.373",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.011 290.008L14.1992 379.626",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.008L31.6172 421.67",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.009 290.008L55.3945 460.477",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.011 290.008L84.9375 495.082",
			stroke: "#0669FD",
			strokeOpacity: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.008 290.008L119.539 524.639",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.008L158.348 548.418",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.009 290.008L200.391 565.836",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.01 290.008L244.645 576.447",
			stroke: "#0669FD",
			strokeOpacity: .8,
			strokeMiterlimit: 10
		})
	]
});
export default SvgCircleIllustration;
